/* eslint-disable no-continue */
/* eslint-disable no-restricted-syntax */
import { MockDirectives } from 'types/Mock';

export const parseMockDirectives = (headerValue: string, consumer = 'product-fe'): MockDirectives => {
  const directives: MockDirectives = {};

  if (!headerValue) return directives;

  const parsedDirectives = headerValue
    .toLowerCase()
    .split(',')
    .map((directive) => directive.trim())
    .filter((directive) => directive.startsWith(`${consumer}.`))
    .filter((directive) => directive.includes('='));

  for (const directive of parsedDirectives) {
    const equalsIndex = directive.indexOf('=');
    const provider = directive.substring(0, equalsIndex).trim().replace(`${consumer}.`, '');
    const scenario = directive.substring(equalsIndex + 1).trim();

    if (!scenario || !provider) continue;

    directives[`${provider}`] = scenario;
  }

  return directives;
};

export const getMockScenarioForProvider = (directives: MockDirectives, providerName: string): string | undefined =>
  directives[providerName.toLowerCase()];
